import { Card, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import {
  RATINGS_COLUMN_WIDTH,
  RATINGS_ICON_WIDTH,
} from "@src/appV2/redesign/Tiers/utils/constants";

export function RatingsTitleCard() {
  return (
    <Card sx={{ border: "1px solid transparent" }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          paddingX: 6,
          paddingY: 2,
        }}
      >
        {/* Empty space to match tier icon */}
        <Box sx={{ width: RATINGS_ICON_WIDTH }} />
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ flexGrow: 1, marginLeft: 3 }}
        >
          <Text
            semibold
            variant="body2"
            align="center"
            sx={{
              minWidth: RATINGS_COLUMN_WIDTH,
              wordBreak: "break-word",
            }}
          >
            On-time
          </Text>
          <Text
            semibold
            variant="body2"
            align="center"
            sx={{ minWidth: RATINGS_COLUMN_WIDTH, wordBreak: "break-word" }}
          >
            Completion
          </Text>
          <Text
            semibold
            variant="body2"
            align="center"
            sx={{ minWidth: RATINGS_COLUMN_WIDTH, wordBreak: "break-word" }}
          >
            Late cancels
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
}
